/**
 * Copy campaign group — in the open group's master config pop-up: puts the
 * group (its master config and containers) on the clipboard; any other
 * country's Automation board then offers to paste it.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Copy } from 'lucide-react';

import { Button } from '@/components/ui';
import type { GroupEntry } from '@/features/drop-generator/components/campaign/campaign-scope';
import { useToast } from '@/providers/ToastProvider';

import { writeClip } from './group-copy-clipboard';
import { useCountryName } from './use-country-name';

interface Props {
  countryKey: string;
  group: GroupEntry;
  masterName: string;
  onCopied: () => void;
}

export const CopyGroupButton: FC<Props> = ({ countryKey, group, masterName, onCopied }) => {
  const countryName = useCountryName(countryKey);
  const toast = useToast();
  const copy = () => {
    writeClip({ source: { countryKey, groupKey: group.key }, countryName, label: group.label, masterName, containers: group.containerCount, copiedAt: new Date().toISOString() });
    toast.success(`Copied ${group.label}`, 'Open another country’s Automation board to paste it.');
    onCopied();
  };
  return (
    <Button type="button" variant="outline" size="sm" aria-label="Copy campaign group" title="Copy this campaign group — its master config and containers — to paste it on another country’s board" onClick={copy}>
      <Copy className="mr-1 h-3.5 w-3.5" /> Copy<span className="hidden sm:inline">&nbsp;group</span>
    </Button>
  );
};
